export default {

    SQUARE_UP_APPLICATION_ID: 'sandbox-sq0idp-6o35glEKAVY0GtW8MmMvhg',

    SHOPIFY_RETAILER_TYPE: 'Shopify',
    AMAZON_RETAILER_TYPE: 'Amazon',


    BroadcastMessages: {
        TOGGLE_POPUP_BAG: 'togglePopupBag',
        CART_PAGE_REQUESTED: 'cartPageRequested',
        SESSION_CHANGED: 'sessionChanged',
        DISPLAY_POPUP_BAG: 'displayPopupBag',
        HIDE_POPUP_BAG: 'hidePopupBag',
        POPUP_BAG_CHANGED: 'popupBagChanged',
        CREATE_GROUP_ORDER: 'createGroupOrder'
    },

    UserTypes: {
      NormalUser: null,
      StoreAdmin: 1
    },

    RootEvents: {
        CART_CHANGED: 'cartChanged',
        PAYMENT_STATUS_CHANGED: 'paymentStatusChanged',
        USER_PROFILE_UPDATED: 'userProfileUpdated',
        DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE: 'DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE'
    },

    WindowMode: {
        minimized: 'MINIMIZED',
        maximized: 'MAXIMIZED'
    },
    Notifications: {
        chatNotification: 'resources/media/chat_notif.wav',
        newCartItemNotification: 'resources/media/chat_notif.wav',
    },
    Events: {
        WINDOW_WIDTH_CHANGED: 'windowWidthChanged',
        WINDOW_STATE_CHANGED: 'windowStateChanged',
        WINDOW_SCROLL: 'windowScroll',
        GROUP_ORDER_STATUS_CHANGED: 'groupOrderStatusChanged',
        ORDER_CREATED: 'setupOrderFinished',
        ORDER_CANCELLED: 'orderStatusCancelled',
        ORDER_CLEAR_ITEMS: 'clearCartItems',
        ORDER_CHANGED: 'orderChanged',
        ORDER_CANCELLED_BY_OWNER: 'orderCancelledByOwner',
        ORDER_CLEARED_BY_OWNER: 'orderClearedByOwner',
        USER_REMOVED_BY_OWNER: 'userRemovedByOwner',
        USER_JOINED_OTHER_CART: 'userJoinedOtherCart',
        ORDER_CHECKED_OUT: 'orderCheckedOut',
        LEFT_ORDER: 'participantLeftOrder',
        USER_LOGGED_OUT: 'userLoggedOut',
        USER_LOGGED_IN: 'userLoggedIn',
        INVITATION_ACCEPTED: 'invitationAccepted',
        INVITATION_FAILED_DUE_TO_CART_CLOSED: 'invitationFailedDueToCartClosed',
        CHAT_MESSAGE_RECEIVED: 'chatMessageReceived',
        CART_ITEMS_CHANGED: 'cartItemsUpdated',
        CART_OWNERSHIP_TRANSFERRED: 'CartOwnershipTransferred',
        REALTIME_CHAT_RECEIVED: 'RealtimeChatMessageReceived',
        EXTERNAL_PRODUCT_DETAIL_REQUESTED: 'externalProductDetailRequested',
        ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE: 'AddPeopleAdvanceToNextPage',
        ORDER_CREATION_CANCEL_REQUESTED: 'OrderCreationCancelRequest',
        VERSION_PAGE_REQUESTED: "VersionPageRequested",
        LOGIN_PAGE_CANCEL_REQUESTED: 'LogInPageCancelRequest',
        ON_WINDOW_UNLOADING: 'WINDOW_UNLOADING',
        SIGNALR_CONNECTED: 'SignalrConnected',
        CANCEL_INVITATION: 'CANCEL_INVITATION',
        WINDOW_RECEIVED_MESSAGE: 'WINDOW_MESSAGE_RECEIVED',
        OPEN_SPLASH_SCREEN: 'OPEN_SPLASH_SCREEN',
        DELETE_CONTACT_COMPLETE: 'DELETE_CONTACT_COMPLETE',
        DIALOG_OPENED: 'DIALOG_OPENED',
        DIALOG_CLOSED: 'DIALOG_CLOSED',
        BACK_BUTTON_CLICKED: "BACK_BUTTON_CLICKED",
        ACCEPT_INVITES: "ACCEPT_INVITES"
    },

    SignalRHubStates: {
        CONNECTING: 0,
        CONNECTED: 1,
        RECONNECTING: 2,
        DISCONNECTED: 4
    },

    ElementAnchors: {
        TOP_NAVIGATION_BAR: 'top-navbar',
        TOP_NAVIGATION_BAR_PLACEHOLDER: 'top-navbar-placeholder',
        TOP_MOBILE_TOOLBAR: 'top-mobile-toolbar'
    },

    Timeouts: {
        POOLING_INTERVAL: 6000
    },

    SessionStorage: {
        AUTH_TOKEN: 'authToken',
        USER_EMAIL: 'userEmail',
        USER_NAME: 'userName',
        USER_FIRST_NAME: 'userFirstName',
        USER_LAST_NAME: 'userLastName',
        USER_DATA: 'userData',
        CART: 'cart',
        DELIVERY_PHONE: 'deliveryPhone',
        DELIVERY_ADDRESS: 'deliveryAddress',
        IS_INVITE: 'isInvite',
        NEW_ORDER_CONFIGURATION: 'newOrderConfiguration',
        ANTI_FORGERY_TOKEN: 'requestVerificationToken',
        AwaitingInvitation: 'awaiting_invitation',
        UnreadChatMessages: 'unread_chat_messages',
        CARTONOMY_BUILD_TIME: 'CARTONOMY_BUILD_TIME',
        CARTONOMY_BUILD_VERSION: 'CARTONOMY_BUILD_VERSION',
        LAST_STATE_NAME: 'LAST_STATE_BEFORE_UNLOAD',
        LAST_WINDOW_STATE: 'LAST_WINDOW_STATE',
        InvitationUserInvalid: 'InvitationUserInvalid',
        CREATE_ORDER_CONFIGURATION: 'CREATING_ORDER_CONFIGURATION',
        CREATE_ORDER_CURRENT_TAB: 'CREATING_ORDER_CURRENT_TAB',
        LINKING_SOCIAL_ACCOUNT: 'LINKING_SOCIAL_ACCOUNT',
        SAFARI_WARNING_SHOWED: 'SAFARI_WARNING_SHOWED',
        RETAILER_DATA: 'RETAILER_DATA_CHECK'
    },

    RoutingStates: {
        ABOUT: 'about',
        CATALOG: 'catalog',
        USER_PROFILE: 'profile',
        STORE_ADMIN: 'storeAdmin',
        START_CHECKOUT: 'start_checkout',
        CHECKOUT: 'checkout',
        CHECKOUT_FULL_MIXED: 'fullmixed',
        CART: 'cart',
        INVITED_PEOPLE: 'invited_people',
        CHAT: 'chat',
        INVITE: 'invite',
        CONFIRM_TICKET: 'confirm_ticket',
        PAY: 'pay',
        CONFIRM_ORDER: 'confirm_order',
        LOGIN_TICKET: 'login_ticket',
        PAYPAL_REDIRECT: 'paypal',
        ORDER_SUMMARY_PAGE: 'orderSummaryPage',
        OPEN_CARTS: 'openCarts',
    },

    Pagination: {
        PAGE_LIMIT: 10
    },

    CartDetails: {

        DEADLINE_HOURS: 1,

        DeliveryMethods: {
            DELIVERY: "DELIVERY",
            PICKUP: "PICKUP",
            SHIPPING: "SHIPPING",
            DEFAULT: "DELIVERY"
        },

        PaymentMethods: {
            SINGLE: "single",
            MULTIPLE: "multiple",
            DEFAULT: "multiple",
            MIXED: 'mixed',
            FULL_MIXED: 'fullmixed',
            USER_SELECT: 'user-select',
            SELF: 'self'
        },

      BudgetTypes : {
        PER_CART: 'per-cart',
        PER_USER: 'per-user',
        USER_SELECT: 'user-select',
      },

        ShippingMethods: {
            DEFAULT: "default"
        },

        Participant: {
            Status: {
                OWNER: 'OWNER',
                INVITE_SENT: 'INVITESENT',
                INVITED: 'INVITED',
                JOINED: 'JOINED',
                DECLINED: 'DECLINED',
                REMOVED: 'REMOVED',
                LEFT: 'LEFT'
            }
        }
    },

    AddressType: {
        BILLING: "billing",
        SHIPPING: "shipping"
    },

    OrderSetupTabs: {
        WELCOME: 'welcome',
        DELIVERY_MODE: 'deliveryMode',
        DELIVERY_ADDRESS: 'deliveryAddress',
        PAY_MODE: 'payMode',
        DEADLINE: 'deadline',
        BUDGET: 'budget',
        ADD_PEOPLE: 'addPeople',
        PREVIEW: 'preview',
        FINISH: 'finish',
        CANCEL: 'cancel',
        CANCELEDITING: 'cancelEditing',
        PAYMENT_DETAILS: 'paymentDetails',
        ORDER_CREATE_CONFIRM: 'orderCreateConfirm',
        CONFIRM_DELETE_CONTACT: 'confirmDeleteContact',
        INVITE_WELCOME: 'inviteWelcome'
    },

    InvitationTypes : {
        normal: 1,
        share: 2
    },

    CartonomyMode : {
        default: 0,
        marketing: 1
    },

    PAYPAL_CHECKOUT_URL: 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=',

    EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    DEFAULT_AVATAR_URL: 'resources/images/in_page_img/def_avatar.png',
    DEFAULT_PRODUCT_IMAGE: '/resources/images/in_page_img/coming_soon_image_1.jpg',
    EMPTY_SESSION_ID: '00000000-0000-0000-0000-000000000000',
    CHAT_MESSAGES_LIMIT: 5,
    MAXIMUM_CHAT_TEXT_LENGTH: 256,
    CHAT_TIME_LABEL: '[timeUtc]',
    INVITE_LINK: '?t=1/#/invite/',

    GENERAL_MILLS_POC: ['pillsbury.com','bettycrocker.com','tablespoon.com'],
    CART_NAME_DEFAULT_VALUE: 'client.external.custom_cart_name'
}



// WEBPACK FOOTER //
// ./src/utils/CommonConstants.js